import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { ListingsProfitReportFormIO, TListingsProfitReportFormIOCodec } from "../formIO/ListingsProfitReportFormIO";

export const ListingsProfitReportPagePartial: TRequiredCodec<{
    report: TListingsProfitReportFormIOCodec;
}> = required({
    report: ListingsProfitReportFormIO,
});

export type TListingsProfitReportPagePartialCodec = typeof ListingsProfitReportPagePartial;
